import { SelectOption, SelectOptionWithColor } from './SelectOption';

export const isSelectOptionWithColor = (
  selectOption: SelectOption | SelectOptionWithColor
): selectOption is SelectOptionWithColor => {
  return 'color' in selectOption;
};
